// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TMh6XQlYko_LYfUHXIx9 {
  width: 100;
  display: flex;
  height: 68px;
  justify-content: space-between;
  padding: 8px 16px;
  align-items: center;
  border-top: 1px solid #C1C1C1;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/componentes/Tabela/TabelaRodape/TabelaRodape.module.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AACJ","sourcesContent":[".footerTable {\r\n    width: 100;\r\n    display: flex;\r\n    height: 68px;\r\n    justify-content: space-between;\r\n    padding: 8px 16px;\r\n    align-items: center;\r\n    border-top: 1px solid #C1C1C1;\r\n    background-color: #fff;\r\n}"],"sourceRoot":""}]);
// Exports
export var footerTable = `TMh6XQlYko_LYfUHXIx9`;
export default ___CSS_LOADER_EXPORT___;
